import Activities from '@/components/Activities'
import { useParams } from 'react-router-dom'
import { IPermissionProps } from '@/types/shared'
import { getTicketLogs } from '@/modules/Ticket/services'

const TicketLog: React.FC<IPermissionProps> = () => {
    const { ticketID } = useParams()

    return (
        <Activities
            translationNamespace="ticket"
            className="mt-2"
            apiCall={(payload) =>
                getTicketLogs({
                    ticket_id: Number(ticketID),
                    params: payload,
                })
            }
            queryKey={`ticket-logs-${ticketID}`}
        />
    )
}
export default TicketLog
